import { makeStyles } from "@material-ui/core/styles";

const customInputFieldsStyles = makeStyles((theme) => ({
  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
  },
  cardContentInput1: {
    padding: "0.2px 6px",
  },
}));

export default customInputFieldsStyles;
